import { render, staticRenderFns } from "./rule-form.vue?vue&type=template&id=86e30afa&scoped=true"
import script from "./rule-form.vue?vue&type=script&lang=ts"
export * from "./rule-form.vue?vue&type=script&lang=ts"
import style0 from "./rule-form.vue?vue&type=style&index=0&id=86e30afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e30afa",
  null
  
)

export default component.exports